import * as actionTypes from 'state/actions/actionTypes';

const INITIAL_STATE = {
  firstName: '',
  lastName: '',
  email: '',
  timeZone: '',
  middleInitial: '',
  preferredLanguage: '',
  suffix: '',
  externalId: '',
  profiles: {},
  contactPaths: [],
  pageServices: [],
  timezones: [],
  formatCountries: {},
  isEmailEditable: true,
  hasUniversalProfile: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_PROFILE_INIT.SUCCESS:
      return {
        state,
        ...action.payload,
      };
    case actionTypes.HAS_SEND_NOTIFICATION_PERMISSION.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.RECAPTCHA_VERIFIED.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case actionTypes.SEND_TEST_NOTIFICATION.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
